import { get, post, put, remove } from './api.service'
import toastService from './toast.service'

const QuestionService = {
	getQuestion(questionId: string, options?: any) {
		return get(`/questions/${questionId}`, options)
	},

	getQuestions(params: any, options?: any) {
		return get('/questions', params, options)
	},

	getQuestionAnswers(params: any, options?: any) {
		return get('/questions/answers', params, options)
	},

	createQuestionAnswers(params: any) {
		return post('/questions/answers', params)
	},

	updateQuestionAnswers(params: any) {
		return put('/questions/answers', params)
	},

	createQuestion(params: any) {
		return post('/questions', params)
	},

	updateQuestion(id, params: any) {
		return put(`/questions/${id}`, params)
	},

	updateQuestions(params: any) {
		return put(`/questions`, params)
	},

	removeQuestion(id) {
		return remove(`/questions/${id}`)
	},

	formatCompanyQuestions(questionRes: {}) {
		return Object.values(questionRes)
			.map((q: any) => {
				return {
					id: q.id,
					...q.attributes,
				}
			})
			.sort((a, b) => a.listPosition - b.listPosition)
	},

	getCompanyQuestionsFormatted: async function ({ parentId, context }) {
		const qFilterParams = {
			filter: {
				context: context,
				parent_id: parentId,
			},
			sort: 'list_position',
		}
		// const qRes = await QuestionService.getQuestions(qFilterParams)
		const qRes = await this.getQuestions(qFilterParams)

		if (qRes.question) {
			const qList = this.formatCompanyQuestions(qRes.question)
			return qList
		}
		return []
	},

	formatCompanyQuestionsAnswers(
		questionAnswerRes: {},
		asArray: boolean = true
	) {
		let res = [
			...Object.values(questionAnswerRes).map((a: any) => {
				return {
					...a.attributes,
					id: a.id,
				}
			}),
		]
		if (!asArray) {
			const objRes: any = {}
			for (let answer of res) {
				objRes[answer.questionId] = answer
			}
			res = objRes
		}
		return res
	},

	getCompanyQuestionsAnswersFormatted: async function ({
		contextId,
		contextType,
	}) {
		// debugger;
		//context_id === challenge_id
		const aFilterParams = {
			filter: {
				context_id: contextId,
				context_type: contextType,
			},
		}
		// get answers here
		const aRes = await this.getQuestionAnswers(aFilterParams)

		if (aRes.questionAnswer) {
			const aList = this.formatCompanyQuestionsAnswers(aRes.questionAnswer)
			// setAnswers(aList)
			return aList
		}

		return []
	},

	saveAnswers: async function ({ answers, contextId, contextType }) {
		const newAnswersParams = {
			answers: (typeof answers === 'object' ? Object.values(answers) : answers)
				.filter((a) => !a.id)
				.map((a) => {
					return {
						...a,
						contextId,
						contextType: contextType,
					}
				}),
		}

		const updateAnswersParams = {
			answers: Object.values(answers).filter((a: any) => a.id),
		}

		try {
			const saveRes = newAnswersParams.answers.length
				? await QuestionService.createQuestionAnswers(newAnswersParams)
				: null
			const updateRes = updateAnswersParams.answers.length
				? await QuestionService.updateQuestionAnswers(updateAnswersParams)
				: null

			if (saveRes || updateRes) {
				// this.getCompanyQuestionsAnswersFormatted({ contextId, contextType })
				toastService.showSuccess('Answers saved!')
			}
		} catch (e) {
			toastService.showError('Failed to save profile')
		}
	},
}

export default QuestionService
